'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProviderWrapper } from './theme';
import { ThirdwebProvider } from 'thirdweb/react';
import { VersionCheckProvider } from '../hooks/useVersionCheck';
import { VersionUpdatePopup } from '../components/VersionUpdatePopup';
import { DeviceApprovalProvider } from './device-approval-provider';
import { AlertProvider } from './alert-provider';
import { SessionProvider } from '../hooks/useSession';
import { OnchainKitWrapper } from './onchainkit-provider';

// Create a client outside the component to avoid recreating on every render
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      // 1 minute
      refetchOnWindowFocus: false
    }
  }
});
export function Providers(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <VersionUpdatePopup />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <QueryClientProvider client={queryClient}><SessionProvider><OnchainKitWrapper><ThirdwebProvider><VersionCheckProvider><AlertProvider><DeviceApprovalProvider><ThemeProviderWrapper>{children}{t1}</ThemeProviderWrapper></DeviceApprovalProvider></AlertProvider></VersionCheckProvider></ThirdwebProvider></OnchainKitWrapper></SessionProvider></QueryClientProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}